export default __webpack_public_path__ + "static/pragicts-cloudops-sase-0269c4a0135db37d9fc253e436674b39.jpg";